export default __webpack_public_path__ + "static/media/Opel.ec4eafc4.jpg";